import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { scrollToId } from "../hooks/useLenis";

export function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;
  return (
    <button
      data-testid="back-to-top-button"
      onClick={() => scrollToId("#home")}
      aria-label="Back to top"
      className="fixed bottom-[104px] right-[26px] z-[150] flex h-10 w-10 items-center justify-center rounded-full border border-[#C9A227]/40 bg-[#07111F]/80 text-[#C9A227] backdrop-blur-md hover:bg-[#C9A227] hover:text-[#07111F] transition-[background-color,color] duration-300"
    >
      <ArrowUp size={17} />
    </button>
  );
}
